const API_BASE = '/api';

class ApiClient {
  constructor() {
    this.token = localStorage.getItem('curiosaurus_token');
  }

  setToken(token) {
    this.token = token;
    if (token) {
      localStorage.setItem('curiosaurus_token', token);
    } else {
      localStorage.removeItem('curiosaurus_token');
    }
  }

  async request(method, path, body = null) {
    const headers = { 'Content-Type': 'application/json' };
    if (this.token) {
      headers['Authorization'] = `Bearer ${this.token}`;
    }

    // cache:'no-store' → jamais de réponse GET servie depuis le cache navigateur
    // (sinon le pull-to-refresh tourne mais réaffiche des données périmées).
    const opts = { method, headers, cache: 'no-store' };
    if (body) opts.body = JSON.stringify(body);

    const res = await fetch(`${API_BASE}${path}`, opts);

    if (!res.ok) {
      const err = await res.json().catch(() => ({ detail: 'Erreur réseau' }));
      throw new Error(err.detail || `Erreur ${res.status}`);
    }

    return res.json();
  }

  // Auth
  register(data) { return this.request('POST', '/auth/register', data); }
  login(data) { return this.request('POST', '/auth/login', data); }
  refreshToken() { return this.request('POST', '/auth/refresh'); }
  getMe() { return this.request('GET', '/auth/me'); }
  deleteAccount() { return this.request('DELETE', '/auth/me'); }

  // Signalements + Administration (compte is_admin)
  reportQuestion(questionId, reason = '') { return this.request('POST', '/reports', { question_id: questionId, reason }); }
  getReports(includeResolved = false) { return this.request('GET', `/reports?include_resolved=${includeResolved}`); }
  resolveReport(reportId) { return this.request('POST', `/reports/${reportId}/resolve`); }
  adminListUsers(includeInactive = true) { return this.request('GET', `/admin/users?include_inactive=${includeInactive}`); }
  adminDeactivateUser(userId) { return this.request('POST', `/admin/users/${userId}/deactivate`); }
  adminReactivateUser(userId) { return this.request('POST', `/admin/users/${userId}/reactivate`); }

  // Quiz
  getThemes() { return this.request('GET', '/quiz/themes'); }
  startQuiz(themeId) { return this.request('POST', `/quiz/start?theme_id=${themeId}`); }
  getQuestion(sessionId) { return this.request('GET', `/quiz/session/${sessionId}/question`); }
  submitAnswer(data) { return this.request('POST', '/quiz/answer', data); }
  getSessionSummary(sessionId) { return this.request('GET', `/quiz/session/${sessionId}/summary`); }
  getStats() { return this.request('GET', '/quiz/stats'); }

  // Cards
  getCards(themeId = null) {
    const params = themeId ? `?theme_id=${themeId}` : '';
    return this.request('GET', `/cards/${params}`);
  }

  // Tree
  getTreeState() { return this.request('GET', '/tree/state'); }

  // Connections
  getConnections() { return this.request('GET', '/connections/'); }
  getUnreadConnections() { return this.request('GET', '/connections/unread-count'); }
  getConnectionProgress() { return this.request('GET', '/connections/progress'); }
  markConnectionRead(id) { return this.request('POST', `/connections/${id}/read`); }
  updateProfile(data) { return this.request('PUT', '/auth/profile', data); }
  startBlitz() { return this.request('POST', '/quiz/blitz/start'); }
  answerBlitz(sessionId, questionId, answerId) { return this.request('POST', `/quiz/blitz/${sessionId}/answer`, { question_id: questionId, answer_id: answerId }); }
  getBlitzRanking() { return this.request('GET', '/quiz/blitz/ranking'); }

  // Missions
  getTodayMissions() { return this.request('GET', '/missions/today'); }

  // Thermometer
  getThermometers() { return this.request('GET', '/tree/thermometers'); }

  // Ranking
  getWeeklyRanking() { return this.request('GET', '/ranking/weekly'); }

  // Achievements
  getAchievements() { return this.request('GET', '/achievements'); }

  // Premium (déblocage « tout débloquer »)
  getPremiumStatus() { return this.request('GET', '/premium/status'); }
  unlockPremium() { return this.request('POST', '/premium/unlock'); }

  // ── Duels ──
  getDuelOpponents() { return this.request('GET', '/duels/opponents'); }
  getDuelThemesWith(opponentId) { return this.request('GET', `/duels/themes-with/${opponentId}`); }
  createDuel(data) { return this.request('POST', '/duels/challenge', data); }
  getMyDuels() { return this.request('GET', '/duels/my'); }
  acceptDuel(duelId) { return this.request('POST', `/duels/${duelId}/accept`); }
  declineDuel(duelId) { return this.request('POST', `/duels/${duelId}/decline`); }
  getDuelQuestions(duelId) { return this.request('GET', `/duels/${duelId}/questions`); }
  submitDuelAnswers(duelId, data) { return this.request('POST', `/duels/${duelId}/submit`, data); }
  answerDuelQuestion(duelId, data) { return this.request('POST', `/duels/${duelId}/answer`, data); }
  getDuelLeaderboard() { return this.request('GET', '/duels/leaderboard'); }
  getPendingDuels() { return this.request('GET', '/duels/pending-count'); }

  // ── Amis ──
  getFriends() { return this.request('GET', '/friends/list'); }
  getFriendRequests() { return this.request('GET', '/friends/requests'); }
  getPendingFriends() { return this.request('GET', '/friends/pending-count'); }
  searchUsers(q) { return this.request('GET', `/friends/search?q=${encodeURIComponent(q)}`); }
  sendFriendRequest(userId) { return this.request('POST', '/friends/request', { user_id: userId }); }
  acceptFriendRequest(requestId) { return this.request('POST', `/friends/${requestId}/accept`); }
  declineFriendRequest(requestId) { return this.request('POST', `/friends/${requestId}/decline`); }
  removeFriend(userId) { return this.request('DELETE', `/friends/${userId}`); }
}

const api = new ApiClient();
export default api;
